import React from 'react';
import PropTypes from 'prop-types';
import styles from '../css/components/readOnlyInput.module.css'; // New CSS file

const ReadOnlyInput = ({ label, value }) => {
    return (
        <div className={styles.readOnlyContainer}>
            {label && (
                <label className={styles.readOnlyLabel}>{label}</label>
            )}
            <div className={styles.readOnlyValue}>{value}</div>
        </div>
    );
};

ReadOnlyInput.propTypes = {
    label: PropTypes.string,
    value: PropTypes.any, // Allows any value type to be displayed
};

export default ReadOnlyInput;